import styles from '@ui/components/Stars/Stars.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import React, { cloneElement, useMemo } from 'react';
import classNames from 'classnames';
import {
  FormLabel,
  FormRadio,
  FormRadioGroup,
  VisuallyHidden,
} from '@ariakit/react';
import PropTypes from 'prop-types';

const Stars = ({
  name,
  ratings: defaultRatings,
  className = null,
  iconActive,
  iconInactive,
  store,
  theme = 'default',
}) => {
  const { values } = store.useState();
  const DefaultIconActive = useMemo(
    () => <FontAwesomeProIcon icon="star" role="presentation" type="solid" />,
    [],
  );
  const DefaultIconInactive = useMemo(
    () => <FontAwesomeProIcon icon="star" role="presentation" type="regular" />,
    [],
  );
  const ratings = useMemo(
    () => (Array.isArray(defaultRatings) ? defaultRatings : [1, 2, 3, 4, 5]),
    [defaultRatings],
  );

  return (
    <FormRadioGroup
      aria-label="rating"
      className={classNames(styles.stars, className)}
      name={store.names[name]}
      store={store}
    >
      {ratings.map((rating, index, array) => {
        const icon =
          array.indexOf(values[name]) >= array.indexOf(rating)
            ? iconActive || DefaultIconActive
            : iconInactive || DefaultIconInactive;

        return (
          <FormLabel
            className={classNames(styles.container, styles[theme], className)}
            key={rating}
            store={store}
          >
            <VisuallyHidden>
              <FormRadio
                className={styles.input}
                id={`${rating}-${name}`}
                name={store.names[name]}
                store={store}
                tabIndex={-1}
                value={rating}
              />
            </VisuallyHidden>
            {cloneElement(icon, { className: styles.icon })}
          </FormLabel>
        );
      })}
    </FormRadioGroup>
  );
};

Stars.propTypes = {
  className: PropTypes.string,
  iconActive: PropTypes.node,
  iconInactive: PropTypes.node,
  name: PropTypes.string.isRequired,
  ratings: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ),
  /* eslint-disable react/forbid-prop-types */
  /** `useFormStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  theme: PropTypes.oneOf(['default', 'contrast']),
};

export default Stars;
